<template>
  <v-form ref="form" v-model="isValid" lazy-validation>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-text-field
              v-model="nazwa"
              label="Nazwa"
              :rules="[nazwa_rules.required, nazwa_rules.min_length]"
              required
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <v-textarea
              v-model="opis"
              label="Opis"
              rows="3"
              :rules="[opis_rules.required, opis_rules.min_length]"
              required
          ></v-textarea>
        </v-col>
        <v-col cols="12" sm="6">
          <DatePicker
              v-model="data_utworzenia"
              pickerLabel="Data Utworzenia"
              required
          ></DatePicker>
        </v-col>
        <v-col cols="12" sm="6">
          <v-select
              v-model="wybrany_status"
              :items="statusy"
              item-text="text"
              item-value="value"
              return-object
              label="Status"
              required
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6">
          <DatePicker
              v-model="data_zakonczenia_anulacji"
              pickerLabel="Data Zakończenia/Anulacji"
              required
          ></DatePicker>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-btn color="success" @click="handleSubmit">Zapisz</v-btn>
        </v-col>
        <v-col cols="6" class="text-right">
          <v-btn @click="closeForm" color="error">Anuluj</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import DatePicker from '@/components/shared/DatePicker.vue';
import dayjs from "dayjs";
import {planyTerapiiService} from "@/services/planyTerapii.service";
import swal from "sweetalert";

export default {
  name: "CelPlanuZdrowieniaEdit",
  props: ["plan_zdrowienia_id","edytowany_cel"],
  components: {
    DatePicker
  },
  data() {
    return {
      id: 0,
      isValid: false,
      nazwa: '',
      status: '',
      opis: '',
      data_utworzenia: dayjs().format("YYYY-MM-DD"),
      data_zakonczenia_anulacji: null,
      statusy: [{ text: 'Planowany', value: 0 }, { text: 'Realizowany', value: 1 }, { text: 'Zrealizowany', value: 2 },{ text: 'Anulowany', value: 3 }],
      wybrany_status: null,
      nazwa_rules: {
        required: value=> !!value || 'Nazwa jest wymagana',
        min_length: value=> !(value && value.length < 3) || 'Nazwa musi posiadać minimum 3 znaki'
      },
      opis_rules: {
        required: value=> !!value || 'Opis jest wymagany',
        min_length: value=> !(value && value.length < 3) || 'Opis musi posiadać minimum 3 znaki'
      },
    }
  },
  watch: {
    edytowany_cel: {
      immediate: true,
      handler(val) {
        if(val != null)
        {
          this.id = val.id
          this.nazwa = val.nazwa
          this.opis = val.opis
          this.data_utworzenia = dayjs(val.dataUtworzenia).format("YYYY-MM-DD")
          this.data_zakonczenia_anulacji = val.dataZakoczeniaAnulacji ?  dayjs(val.dataZakoczeniaAnulacji).format("YYYY-MM-DD") : null
          this.wybrany_status = this.statusy.find(x => x.value === val.status)
        }
      }
    }
  },
  mounted() {
    if(this.edytowany_cel == null) {
      this.wybrany_status = this.statusy[0]
    }
  },
  methods: {
    closeForm() {
      this.$emit('close')
    },
    showError( text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
    handleSubmit() {
      if (this.$refs.form.validate()) {
        if(this.id == 0) {
          planyTerapiiService.createPlanTerapiiCel({
            planTerapiiId: this.plan_zdrowienia_id,
            nazwa: this.nazwa,
            opis: this.opis,
            dataUtworzenia: this.data_utworzenia,
            dataZakoczeniaAnulacji: this.data_zakonczenia_anulacji,
            status: this.wybrany_status.value
          }).then(() => {
            this.$emit('close')
          }).catch(err => {
            if (
                err.response != null &&
                err.response.data != null &&
                err.response.data.error != null
            ) {
              this.showError(false, err.response.data.error.message)
            } else {
              this.showError(false, "Błąd zapisu celu.");
            }
          })
        } else {
          planyTerapiiService.updatePlanTerapiiCel({
            id: this.id,
            planTerapiiId: this.plan_zdrowienia_id,
            nazwa: this.nazwa,
            opis: this.opis,
            dataUtworzenia: this.data_utworzenia,
            dataZakoczeniaAnulacji: this.data_zakonczenia_anulacji,
            status: this.wybrany_status.value
          }).then(() => {
            this.$emit('close')
          }).catch(err => {
            if (
                err.response != null &&
                err.response.data != null &&
                err.response.data.error != null
            ) {
              this.showError(false, err.response.data.error.message)
            } else {
              this.showError(false, "Błąd zapisu celu.");
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>